// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_bootstrap_ts":"8acb0483faa97d11","src_app_pages_init_init_module_ts":"e1de9c0c52e61f58"}[chunkId] + ".js";
};